export const DEFAULT_HEIGHT = '100%';
export const DEFAULT_WIDTH = '100%';
//# sourceMappingURL=constants.js.map